/* eslint-disable eqeqeq */
/* eslint-disable no-mixed-operators */
/* eslint-disable import/no-cycle */
import axios from 'axios'
import { asyncLoading } from 'vuejs-loading-plugin'
import { error as toasdError } from '@core/utils/toasted'
import useCryptoJs from '@core/utils/useCryptoJs'
import { getI18nLanguage } from '@/plugins/i18n'
import themeConfig from '@themeConfig'
import store from '@/store'
import { userConsoleRefresh } from './config/apiRoute'
import router from '../router'

// import { getCurrentInstance } from '@vue/composition-api'
// import { useUtils } from '@core/libs/i18n'

export const API_URL_BACKEND = process.env.VUE_APP_API_URL_BACKEND

// true si `a` es una versión semver menor que `b` ("2.7.5" < "2.8.0").
// Cualquier cosa que no parsee (header ausente, texto) cuenta como "no".
function isOlderVersion(a, b) {
  if (!a || !b) return false
  const pa = String(a).split('.').map(n => parseInt(n, 10))
  const pb = String(b).split('.').map(n => parseInt(n, 10))
  if (pa.some(Number.isNaN) || pb.some(Number.isNaN)) return false
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const x = pa[i] || 0
    const y = pb[i] || 0
    if (x !== y) return x < y
  }

  return false
}

function clearLocalStorage(redirectToLogin = true, reauth = false) {
  localStorage.removeItem('accessToken')

  // Remove userData & Ability from localStorage
  localStorage.removeItem('userData')
  localStorage.removeItem('userAbility')

  // Reset ability
  // vm.$ability.update(initialAbility)

  // Redirect to login page
  if (redirectToLogin) router.push({ name: 'auth-login', params: { reauth } })
}

axios.interceptors.request.use(
  config => config, // Do something before request is sent

  error => Promise.reject(error), // Do something with request error
)

axios.interceptors.response.use(
  response => {
    // Do something before response is sent
    const consoleVersion = response.headers['console-version']
    const { reauth, logout } = response.headers
    const { version } = themeConfig.app

    const isLogout = (logout === 'true')
    const isTrueSet = (reauth === 'true')

    // "Actualización disponible" sólo cuando ESTE bundle es más viejo que lo
    // que anuncia el backend. Con `!==` a secas, un frontend más nuevo que
    // el header (2.8.0 vs 2.7.5) mostraba el banner en cada request y el
    // click recargaba... el mismo bundle: loop sin salida.
    const outdated = isOlderVersion(version, consoleVersion)
    if (isLogout || (isTrueSet && outdated)) {
      clearLocalStorage(false, isTrueSet)
    }

    if (outdated) {
      store.dispatch('app/toggleUpdate', true)
    }

    return response
  },
  async error => {
    // if the system detects user is not logged, itll log out him
    if (
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      error.response?.data &&
      error.response.data.code === 'T002' ||
      error.response.data.code === 'T004'
    ) {
      clearLocalStorage()
    }

    if (
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      error.response?.data &&
      error.response.data.code === 'E500' &&
      error.response.data.message !== 'Not enough segments'
    ) {
      toasdError(error.response.data.message)
    }

    if (
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      error.response?.data &&
      error.response.data.code &&
      error.response.data.code !== 'T001' &&
      error.response.data.code !== 'T002' &&
      error.response.data.code !== 'T004' &&
      error.response.data.code !== 'CL002' &&
      error.response.data.code !== 'CL003'
    ) {
      toasdError(error.response.data.message)
    }

    if (
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      error.response?.data &&
      error.response.data.code === 'T001'
    ) {
      /**
       * Do request to refresh token
       */
      const originalRequest = error.response.config
      // eslint-disable-next-line no-underscore-dangle
      originalRequest._retry = true

      const { userData } = useCryptoJs()
      const refreshToken = userData.value ? userData.value.refresh_token : localStorage.getItem('refreshToken')
      try {
        const response = await axios.post(`${API_URL_BACKEND}v1${userConsoleRefresh}`, null, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'el-token': `Bearer ${refreshToken}`,
            'Accept-Language': getI18nLanguage(),
          },
        })

        const { data } = response

        // store.commit('auth/LOGIN_USER', data.data)
        if (data.ok === 1) {
          localStorage.setItem('accessToken', data.data.access_token)
          originalRequest.headers['el-token'] = `Bearer ${data.data.access_token}`

          if (originalRequest.url.includes('logout')) {
            const originalData = JSON.parse(originalRequest.data)
            originalData.access_token = data.data.access_token
            originalRequest.data = JSON.stringify(originalData)

            store.dispatch('auth/logoutSuccess')
          }

          // router.push('/')

          return axios(originalRequest)
        }

        clearLocalStorage()
      } catch (e) {
        /**
         * if refresh token expired go to Login pages
         */
        if (e.data && (e.data.code === 'T001' || e.data.code === 'T002')) {
          clearLocalStorage()
        }
      }
    }

    // if (error.response.status === 401) {
    //   // store.dispatch('logoutAction')
    // }

    // Do something with response error
    return Promise.reject(error)
  },
)

function buildErrorMessage(error) {
  const errorResponse = {
    ok: 0,
    message: {
      code: String,
      text: String,
    },
    data: null,
  }

  // if (typeof error.response === 'undefined') {
  //   errorResponse.message.text = t('message.apiErrorUndefined')
  // } else if (error.response.status === 401) {
  //   errorResponse.message.text = t('message.apiError401')
  // } else if (error.response.status === 404) {
  //   errorResponse.message.text = t('message.apiError404')
  // } else if (error.response.status === 500) {
  //   errorResponse.message.text = t('message.apiError500')
  // } else if (error.response.status === 405 || error.response.status === 406) {
  //   errorResponse.message.text = t('message.apiError405_406')
  // } else errorResponse.message.text = error.response.data.message.text
  errorResponse.ok = 0
  errorResponse.message.text = error.response.data.message
  errorResponse.message.code = error.response.data.code
  if (error.response.data.data) errorResponse.data = error.response.data.data

  // errorResponse.message.code = 'E999'

  return errorResponse
}

export const apiHttp = async (method, endpoint, data, options = {}, loading = true, version = 'v1') => {
  const { accessToken } = localStorage
  const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'el-token': `Bearer ${accessToken}`,
    'Accept-Language': getI18nLanguage(),
  }

  // eslint-disable-next-line no-prototype-builtins
  if (!options.hasOwnProperty('headers')) {
    // eslint-disable-next-line no-param-reassign
    options.headers = defaultHeaders
  }

  let serviceResponse = {}

  // eslint-disable-next-line no-param-reassign
  method = method.toLowerCase()
  const servicePromise = axios({
    method,
    url: `${API_URL_BACKEND}${version}${endpoint}`,
    data,
    ...options,
  })

  try {
    if (loading) {
      // window.getApp.$emit('LOADING', true)
    }
    asyncLoading(servicePromise).then().catch()
    const [materializedPromise] = await Promise.all([servicePromise])
    serviceResponse = { ...materializedPromise.data }
  } catch (error) {
    serviceResponse = buildErrorMessage(error)
  }

  // vm.$emit('LOADING', false)

  return serviceResponse
}
